import { apiClient } from '../utils/api-client';

/** Somebody the current user may tag in a comment. */
export interface MentionCandidate {
  id: string;
  type: 'user';
  attributes: {
    username: string;
    slug: string;
    full_name: string | null;
    avatar_url: string | null;
  };
}

interface MentionCandidatesResponse {
  data: MentionCandidate[];
}

export const mentionCandidatesService = {
  /**
   * The people the user follows and the people who follow them, mutuals first,
   * matched on handle and full name server-side.
   *
   * Asked of its own endpoint rather than of /api/followings, which is a paged
   * feed of everything followed — gyms included — ordered by activity: reading
   * names off its first page made a quiet partner untaggable.
   *
   * Errors are swallowed on purpose: an autocomplete that toasts while somebody
   * is mid-sentence is worse than one that comes up empty.
   */
  async search(query: string): Promise<MentionCandidate[]> {
    const params = query.trim() ? `?q=${encodeURIComponent(query.trim())}` : '';

    try {
      const response = await apiClient.get(`/api/mention_candidates${params}`, {
        requireAuth: true,
        showErrors: false,
      });
      const body = (await response.json()) as MentionCandidatesResponse;
      return body.data ?? [];
    } catch {
      return [];
    }
  },
};
